import { render, staticRenderFns } from "./CreditNotesPage.vue?vue&type=template&id=6a6c7cd4&scoped=true&"
import script from "./CreditNotesPage.vue?vue&type=script&lang=ts&"
export * from "./CreditNotesPage.vue?vue&type=script&lang=ts&"
import style0 from "./CreditNotesPage.vue?vue&type=style&index=0&id=6a6c7cd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6c7cd4",
  null
  
)

export default component.exports